// BUGS-6633: choose the buyer-tracker subtitle for a returned shipment.
//
// We distinguish two cases from the only signal the tracking API exposes today
// (order.first_delivery_attempt_at):
//   - attempt present -> there was a real delivery attempt, so the return happened
//     "tras intentos de entrega fallidos".
//   - no attempt      -> treat as a requested return and show the existing
//     "Por devolución solicitada" copy, instead of implying failed delivery
//     attempts that never happened (the original bug).
//
// LIMITATION: the "no attempt" branch currently collapses every non-attempt return
// into "requested return". Other reasons can also yield a no-attempt return (e.g.
// undeliverable address, or a cancellation before dispatch) and would be mislabeled.
// Telling those apart needs the real return reason from the backend. When more
// scenarios show up, add the new branches HERE once that backend signal exists.
// Backend side tracked in BUGS-6632 (cancellation/return event propagation).
export const getReturnedDescriptionKey = (order) =>
    order?.first_delivery_attempt_at
        ? 'showOrder.timeline.shipping_description.shipment_returned'
        : 'showOrder.timeline.shipping_description.returning'
